import {Helpers} from "../../../common/js/Helpers";


function setQuantityNeedsCalculationMode(e) {
    Helpers.forEach(Helpers.getParent(e.target, '.cart-item').querySelectorAll('.eventgallery-hide-on-quantity-change'), (elm) => {
        elm.classList.add('invisible-element');
    })
    document.querySelector(".cart-summary").style.display = 'none';
    document.querySelector(".needs-calculation").style.display = 'block';
}

function removeItem(e) {
    e.preventDefault();
    let field = Helpers.getParent(e.target, '.cart-item').querySelector('input.eventgallery-quantity');
    field.value = 0;
    field.form.submit();
}

/**
 * sets the quantity to 0 and submits the form.
 */
function removeAllItems(e) {

    e.preventDefault();
    let response = confirm(window.EventGalleryCartConfiguration?.removeAllItemsWarning);
    if (response === false) {
        return;
    }
    Helpers.forEach(document.querySelectorAll('input.eventgallery-quantity'), (elm) => {
        elm.value = 0;
    })

    let form = Helpers.getParent(e.target, 'form');
    form.submit();
}

document.addEventListener('DOMContentLoaded', () => {
    Helpers.forEach(document.querySelectorAll('.scalepriceinformation'), (elm) => {
        elm.addEventListener('click', function(e) {
            e.preventDefault();
            let elm = Helpers.getParent(e.target, 'div').querySelector('div.scaleprices');
            elm.classList.toggle('zero-height');
        });
    })

    Helpers.forEach(document.querySelectorAll(".cart-item input"), (elm) => elm.addEventListener('change', setQuantityNeedsCalculationMode));
    Helpers.forEach(document.querySelectorAll(".cart-item select"), (elm) => elm.addEventListener('change', (e) => {
        e.target.form.submit()
    }));
    Helpers.forEach(document.querySelectorAll(".cart-item .delete-lineitem"), (elm) => elm.addEventListener('click', removeItem));
    Helpers.forEach(document.querySelectorAll(".eventgallery-removeAll"), (elm) => elm.addEventListener('click', removeAllItems));
    Helpers.forEach(document.querySelectorAll(".cart-item .add-comment"), (elm) => elm.addEventListener('click', (e) => {
        e.preventDefault();
        let textareaContainer = Helpers.getParent(e.target, '.cart-item').querySelector('.comment-area');
        if (textareaContainer) {
            textareaContainer.classList.toggle('zero-height');
        }
    }));

});


